import { Component, OnInit, OnDestroy, Input, ViewChild, ElementRef } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-browser-camera',
  templateUrl: './browser-camera.component.html',
  styleUrls: ['./browser-camera.component.scss'],
})
export class BrowserCameraComponent implements OnInit, OnDestroy {
  @ViewChild('videoEl', { static: true }) videoEl: ElementRef<HTMLVideoElement>;
  @ViewChild('canvasEl', { static: true }) canvasEl: ElementRef<HTMLCanvasElement>;

  // 'rect' (INE) o 'circle' (selfie) — controla overlay y facingMode
  @Input() mode: 'rect' | 'circle' = 'rect';
  @Input() title: string = 'Toma una foto';
  @Input() subtitle: string = 'Encuadra dentro del recuadro y presiona el botón.';

  private stream: MediaStream | null = null;
  loading = true;
  errorMsg = '';

  constructor(private modalController: ModalController) {}

  async ngOnInit() {
    try {
      // En selfie usamos cámara frontal, en INE la trasera (si está disponible).
      const facingMode = this.mode === 'circle' ? 'user' : { ideal: 'environment' };
      this.stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode },
        audio: false
      });
      this.videoEl.nativeElement.srcObject = this.stream;
      this.videoEl.nativeElement.play();
      this.loading = false;
    } catch (e) {
      this.loading = false;
      this.errorMsg = 'No pudimos usar la cámara. Permite el acceso e inténtalo de nuevo.';
    }
  }

  ngOnDestroy() {
    if (this.stream) {
      this.stream.getTracks().forEach(t => t.stop());
      this.stream = null;
    }
  }

  capture() {
    const video = this.videoEl.nativeElement;
    const canvas = this.canvasEl.nativeElement;
    canvas.width = video.videoWidth || 720;
    canvas.height = video.videoHeight || 540;
    const ctx = canvas.getContext('2d');
    if (this.mode === 'circle') {
      // Selfie: la cámara frontal viene espejada en preview; lo invertimos en la captura.
      ctx.translate(canvas.width, 0);
      ctx.scale(-1, 1);
    }
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
    const dataUrl = canvas.toDataURL('image/jpeg', 0.85);
    const base64 = dataUrl.replace(/^data:image\/[a-z]+;base64,/, '');
    this.modalController.dismiss({ base64, dataUrl });
  }

  close() {
    this.modalController.dismiss();
  }
}
